import { render, staticRenderFns } from "./btnCrear.vue?vue&type=template&id=a4976f46&"
import script from "./btnCrear.vue?vue&type=script&lang=js&"
export * from "./btnCrear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports